
<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 10C15 12.7614 12.7614 15 10 15M10 15C7.23858 15 5 12.7614 5 10M10 15V17.5M10 17.5H12.5M10 17.5H7.5M10 12.5C8.61929 12.5 7.5 11.3807 7.5 10V5C7.5 3.61929 8.61929 2.5 10 2.5C11.3807 2.5 12.5 3.61929 12.5 5V10C12.5 11.3807 11.3807 12.5 10 12.5Z"
            stroke="#323030"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    name: "RecordVoiceIcon"
}
</script>
